import { useEffect, useState } from 'react'
// import accredit from '@/stores/accredit'
import icons from '@/assets/icons'
import dayjs from 'dayjs'
import SJCard from '@/components/SJCard'
import SJButton from '@/components/SJButton'
import { ExaminationState, Registration } from '@/services/types/accredit'
import { getRegistrationById } from '@/services/accredit'
import { QRCodeCanvas } from 'qrcode.react'
import SJSite from '@/components/SJSite'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getImage } from '@/utils/utils'
import SJSpace from '@/components/SJSpace'
import OrderInfo from './OrderInfo'
import user from '@/stores/user'
import './index.less'

type State = {
  id: string
  from: 'home' | 'step2' | 'list' | 'order'
}
const RegistrationResult = () => {
  document.title = '评测报名'
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const from = searchParams.get('from') as State['from']
  const [qrcode, setQrcode] = useState('')
  const [result, setResult] = useState<Registration>()

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      if (id) {
        const res = (await getRegistrationById(Number(id))) as unknown as Registration
        setResult(res)
        setQrcode(JSON.stringify({ cmd: 'accredit', data: { id: res.registration_num } }))
        console.log('qrcode', qrcode)
        // const ret = (await getRegistrationGradeInfo({
        //   grade: Number(res.applying_for_grade),
        // })) as unknown as GradeRes
        // accredit.applicant_fee = ret.fee
        // accredit.applicant_code = ret.project_code
      }
    } catch (error) {}
  }

  const goNotice = () => {
    navigate('/registration/notice', {
      state: {
        grade: result?.applying_for_grade || 16,
        from: 'result',
      },
    })
  }
  // const showRegisterNumber = (state: string) => {
  //   return ['paid', 'examining', 'examined', 'failed'].includes(state)
  // }

  return (
    <div className="page registration-result">
      {result ? (
        <div className="main">
          {from === 'step2' && (
            <div className="success">
              <img src={icons.IconSmile} alt="" />
              <span>报名成功，加油备考哦！</span>
            </div>
          )}
          <div className="result-top">
            <div className="date">
              报名时间：{dayjs(result.created_time).format('YYYY-MM-DD HH:mm:ss')}
            </div>
            <div className="notice" onClick={goNotice}>
              <img src={icons.IconNotice} alt="" />
              <span className="fs12">评测须知</span>
            </div>
          </div>
          <SJCard className="result-card">
            <div className={`status status-${result.examination_state}`}>
              {ExaminationState[result.examination_state || 'registered']}
            </div>
            <img className="photo" src={getImage(result.applicant_photo)} alt="" />
            <div className="info-top">
              <div className="info-item top-first">
                <div className="label">姓名</div>
                <div className="value">{result.applicant_name}</div>
              </div>
              <div className="info-item">
                <div className="label">级别</div>
                <div className="value">{result.applying_for_grade}级</div>
              </div>
            </div>
            <div className="info-item">
              <div className="label">准考证号</div>
              <div className="value">
                {result.registration_num}
                {/* {showRegisterNumber(result.examination_state) ? result.registration_num : '***'} */}
              </div>
            </div>
            <div className="info-item">
              <div className="label">证件号</div>
              <div className="value">{result.identification_num}</div>
            </div>
          </SJCard>
          {/* showRegisterNumber(result.examination_state) &&  */}
          {qrcode && (
            <SJCard className="qrcode-card">
              <div className="qrcode-title">准考证二维码</div>
              <div className="qrcode-box">
                <QRCodeCanvas size={240} value={qrcode} level="L" />,
              </div>
            </SJCard>
          )}
          {/* 订单信息和支付，只有操作报名的人可看和操作 */}
          {user.from !== 'CMCC' &&
            result.order_code &&
            result.broker_id === String(user.userPlayer.playerId) && (
              <OrderInfo orderCode={result.order_code}></OrderInfo>
            )}
          <SJSpace height={100} />
          <div className="btn-fixed">
            <SJButton
              size="large"
              type="primary"
              onClick={() => navigate(from === 'step2' ? -5 : -1)}
            >
              {from === 'list' ? '返回' : '返回评测首页'}
            </SJButton>
          </div>
        </div>
      ) : (
        <SJSite />
      )}
    </div>
  )
}

export default RegistrationResult
